import { render, staticRenderFns } from "./EditTextIcon.vue?vue&type=template&id=4a689847&scoped=true"
import script from "./EditTextIcon.vue?vue&type=script&lang=js"
export * from "./EditTextIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a689847",
  null
  
)

export default component.exports